import WorkspaceList from '../Components/Workspace';
import './pages.css';
import { Helmet } from 'react-helmet-async';

const Workspace = () => {
  //return <WorkspaceList />;
  return (
    <>
      <Helmet prioritizeSeoTags defaultTitle="Workspace" defer>
        <title>Silzila</title>
      </Helmet>
      <div className="breadcrumb"></div>
      <WorkspaceList />
    </>
  );
};

export default Workspace;
